export const numbersOnly = (value: string) => value.replace(/[^0-9]/g, "");
export const lettersOnly = (value: string) =>
  value.replace(/[^a-zA-Zа-яА-Я]/g, "");

